import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { ResourceService } from "@smartsoftware/reflex-core";
import { Page, PageParams } from "../paged.datasource";
import { ClientMatterLayout } from "../models/clientMatterLayout.model";
import { Observable } from "rxjs";

@Injectable()
export class ClientMatterLayout_Service extends ResourceService<ClientMatterLayout> {
    protected servicePath: string = "/ClientMatterLayout";

    public ModelType = ClientMatterLayout;

    constructor(protected http: HttpClient) {
        super(http);
    }

    page(pageParams: PageParams): Observable<Page<ClientMatterLayout>> {
        let params = new HttpParams().append("params", encodeURIComponent(btoa(JSON.stringify(pageParams))));
        return this.http.get<Page<ClientMatterLayout>>(`${this.serviceUrl}Page`, { params });
    }
}
